import { makeContextModule } from '@cian/react-utils';

import { IChat } from '../types/chat';

export const { Context: ChatContext, useContext: useChatContext } = makeContextModule<IChat>({
  contextName: 'ChatContext',
});
